import React, { createContext } from 'react';
 import ReactDOM from 'react-dom/client';
 import App from './App';
 import Store from './store/store';
 import Teacherstore from './store/teacherstore';
 import { BrowserRouter } from 'react-router-dom';
 import { GoogleOAuthProvider } from '@react-oauth/google'; // Import the provider

 // Define interfaces
 interface State {
     store: Store;
     teacherstore: Teacherstore;
 }

 // Create instances of Store and Teacherstore
 export const store = new Store();
 export const teacherstore = new Teacherstore();

 export const Context = createContext<State>({
     store,
     teacherstore,
 });

 const clientId = "79542358961-pa0mnbe48vdgvb13hcrng0n5cnpp1epf.apps.googleusercontent.com";

 // Use createRoot instead of ReactDOM.render for React 18
 const rootElement = document.getElementById('root');
 const root = ReactDOM.createRoot(rootElement!);

 root.render(
         <Context.Provider value={{ store, teacherstore }}>
             <GoogleOAuthProvider clientId={clientId}>
                 <BrowserRouter>
                     <App />
                 </BrowserRouter>
             </GoogleOAuthProvider>
         </Context.Provider>
 );